import { render } from "./SaveDialog.vue?vue&type=template&id=528187fc&scoped=true"
import script from "./SaveDialog.vue?vue&type=script&lang=js"
export * from "./SaveDialog.vue?vue&type=script&lang=js"

import "./SaveDialog.vue?vue&type=style&index=0&id=528187fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-528187fc"

export default script